import { Grid } from "@mui/material";

import { useEffect, useState } from "react";
import axios from "axios";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { callCompleted } from "redux/salesPromise";
import Budget from "components/dashboard/TotalSales";
import { dailyDurationSales } from "components/dashboard/TotalSales";

interface BatchProps {
  dayShow: boolean;
  weekShow: boolean;
  monthShow: boolean;
  threeMonthsShow: boolean;
  sixMonthsShow: boolean;
  GetTotalSales?: (newType: dailyDurationSales) => any;
}

interface MetricResult {
  durationSales?: any;
  totalSales: number;
  change: number[];
}

interface BatchResult {
  sales: MetricResult;
  items: MetricResult;
  transactions: MetricResult;
  avgItemsPerTransaction: MetricResult;
}

const emptyResult = {
  sales: { durationSales: 0, totalSales: 0, change: [] },
  items: { totalSales: 0, change: [] },
  transactions: { totalSales: 0, change: [] },
  avgItemsPerTransaction: { totalSales: 0, change: [] },
};

const TotalSalesBatch = ({
  dayShow,
  weekShow,
  monthShow,
  threeMonthsShow,
  sixMonthsShow,
  GetTotalSales,
}: BatchProps) => {
  const dispatch = useDispatch();
  const [result, setResult] = useState<BatchResult>(emptyResult);
  const { promiseInProgress } = usePromiseTracker();

  useEffect(() => {
    dispatch(
      callCompleted({
        totalSales: promiseInProgress,
        totalTransactions: promiseInProgress,
        totalItems: promiseInProgress,
        averageItermsPerTransaction: promiseInProgress,
      }),
    );
  }, [promiseInProgress]);

  useEffect(() => {
    trackPromise(
      axios
        .get("http://192.168.14.53:8000/api/purchase/periodic_sales_batch", {
          params: {
            allStores: true,
            daily: dayShow,
            weekly: weekShow,
            monthly: monthShow,
            threeMonths: threeMonthsShow,
            sixMonths: sixMonthsShow,
          },
        })
        .then((response) => setResult(response.data)),
    );
  }, [weekShow, monthShow, threeMonthsShow, sixMonthsShow]);

  return (
    <>
      <Grid item xs={12} sm={6} xl={6}>
        <Budget
          avgItemTr="1"
          text="SALES"
          isSales={1}
          dayShow={dayShow}
          weekShow={weekShow}
          monthShow={monthShow}
          threeMonthsShow={threeMonthsShow}
          sixMonthsShow={sixMonthsShow}
          GetTotalSales={GetTotalSales}
          dataToAsk={"totalSales"}
          result={result.sales}
        />
      </Grid>

      <Grid item xs={12} sm={6} xl={6}>
        <Budget
          avgItemTr="3"
          text="TRANSACTIONS"
          isSales={2}
          dayShow={dayShow}
          weekShow={weekShow}
          monthShow={monthShow}
          threeMonthsShow={threeMonthsShow}
          sixMonthsShow={sixMonthsShow}
          dataToAsk={"totalTransactions"}
          result={result.transactions}
        />
      </Grid>

      <Grid item xs={12} sm={6} xl={6}>
        <Budget
          avgItemTr="2"
          text="ITEMS"
          isSales={2}
          dayShow={dayShow}
          weekShow={weekShow}
          monthShow={monthShow}
          threeMonthsShow={threeMonthsShow}
          sixMonthsShow={sixMonthsShow}
          dataToAsk={"totalItems"}
          result={result.items}
        />
      </Grid>

      <Grid item xs={12} sm={6} xl={6}>
        <Budget
          avgItemTr="4"
          text="AVG ITEMS/TRANSACTION"
          isSales={2}
          dayShow={dayShow}
          weekShow={weekShow}
          monthShow={monthShow}
          threeMonthsShow={threeMonthsShow}
          sixMonthsShow={sixMonthsShow}
          dataToAsk={"averageItemsPerTransaction"}
          result={result.avgItemsPerTransaction}
        />
      </Grid>
    </>
  );
};

export default TotalSalesBatch;
